import { useDispatch } from 'react-redux';
import { useAppNowUtc } from '@mews/framework';
import { GeneralArea, useRepositoryMutation } from '@mews-commander/data-access';
import { useCurrentLoggedInSession, useCurrentUser } from '@mews-commander/core';
import { createUUID } from '@mews/std';
import { redirectToSignIn } from '../../../../app/actions/common';
import { lockUserSession } from './useLockscreenStore';

export const useLockMutation = () => {
    const dispatch = useDispatch();
    const user = useCurrentUser();
    const nowUtc = useAppNowUtc().value;
    const { accessToken } = useCurrentLoggedInSession();

    const { mutate } = useRepositoryMutation('generalUsers', 'lock', {
        onSuccess: () => {
            dispatch(redirectToSignIn());
        },
    });

    return () => {
        const deviceId = createUUID();
        lockUserSession({ user, accessToken, nowUtc, deviceId });
        mutate({ deviceId, application: GeneralArea.Commander });
    };
};
